<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_('SWCC000325')" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:content>
			<center-content :scrId="scrId" />
			<task-script-modal :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { TaskScriptModal } from '@common/TaskManagement/Content/Modal';
import CenterContent from '@common/TaskManagement/Content/Content';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TaskManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: { CenterContent, TaskScriptModal },
	data() {
		return {
			screen: {},
			title: 'Task 관리'
			// locations: ['HOME', '시스템 관리', '시스템 관리', 'Task 관리']
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
